import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { tableMinHeight } from '@/components/report-tables/core/utils'

const ResizeHandle = React.memo(function ({ tableHeight, onResize }) {
  const [startPoint, setStartPoint] = useState(false)
  const [currentPoint, setCurrentPoint] = useState(false)
  const onStart = useCallback(e => {
    setStartPoint(e.clientY)
    setCurrentPoint(e.clientY)
  }, [])
  useEffect(() => {
    if (typeof startPoint === 'number') {
      const minPoint = startPoint - tableHeight + tableMinHeight
      const onMove = e => {
        setCurrentPoint(e.clientY >= minPoint ? e.clientY : minPoint)
      }
      const onStop = e => {
        const height = tableHeight + e.clientY - startPoint
        onResize({ height })
        setStartPoint(false)
        setCurrentPoint(false)
      }
      window.document.addEventListener('mousemove', onMove)
      window.document.addEventListener('mouseup', onStop)
      // dispose
      return () => {
        window.document.removeEventListener('pointermove', onMove)
        window.document.removeEventListener('mouseup', onStop)
      }
    }
  }, [onResize, tableHeight, startPoint])

  const style = useMemo(() => {
    const top = typeof (currentPoint) === 'number' && typeof (startPoint) === 'number' ? currentPoint - startPoint : 0
    const style = {
      top: top
    }
    if (top > 0) {
      style.zIndex = 10000
    }
    return style
  }, [currentPoint, startPoint])
  return (
    <div className='table-resize-handle-wrapper'>
      <div
        className='table-resize-handle' style={style}
        onMouseDown={onStart} />
    </div>
  )
})

export {
  ResizeHandle
}



// WEBPACK FOOTER //
// ./src/components/report-tables/core/resizeHandle.js